export function isAdminPreview() {
  try {
    return window.frameElement?.getAttribute("isadminpreview") === "true";
  } catch (e) {
    return false;
  }
}
